export { selectAnchorAddresses, selectAnchorIndex } from './anchorIndex'
